import React, { useState, useEffect, useRef } from 'react';
import './App.css';
import LoadingScreen from './components/LoadingScreen';
import BackgroundWatermark from './components/BackgroundWatermark';
import Header from './components/Header';
import LeftSidebar from './components/LeftSidebar';
import RightSidebar from './components/RightSidebar';
import BottomInput from './components/BottomInput';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import DesignSection from './components/DesignSection';
import MobileAppSection from './components/MobileAppSection';
import DigitalMarketingSection from './components/DigitalMarketingSection';
import GlobalTieupsSection from './components/GlobalTieupsSection';
import ContactSection from './components/ContactSection';
import SignUpModal from './components/SignUpModal';

function App() {
  const [loading, setLoading] = useState(true);
  const [leftSidebarOpen, setLeftSidebarOpen] = useState(false);
  const [rightSidebarOpen, setRightSidebarOpen] = useState(false);
  const [showSignUp, setShowSignUp] = useState(false);
  const [user, setUser] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [footerVisible, setFooterVisible] = useState(false);

  const aboutRef = useRef(null);
  const servicesRef = useRef(null);
  const designsRef = useRef(null);
  const mobileAppsRef = useRef(null);
  const digitalMarketingRef = useRef(null);
  const globalTieupsRef = useRef(null);
  const contactRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
      setTimeout(() => {
        aboutRef.current?.scrollIntoView({ behavior: 'smooth' });
      }, 300);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  const scrollToSection = (section) => {
    const refs = {
      about: aboutRef,
      services: servicesRef,
      designs: designsRef,
      mobileApps: mobileAppsRef,
      digitalMarketing: digitalMarketingRef,
      globalTieups: globalTieupsRef,
      contact: contactRef,
    };
    refs[section]?.current?.scrollIntoView({ behavior: 'smooth' });
    setRightSidebarOpen(false);
  };

  const displayToast = (message) => {
    setToastMessage(message);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 3000);
  };

  useEffect(() => {
    const el = contactRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          setFooterVisible(entry.isIntersecting);
        });
      },
      { threshold: 0.5 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [contactRef]);

  const handleSignUp = (userData) => {
    setUser(userData);
    setShowSignUp(false);
    displayToast('Welcome to Gentrobyte AI Labs!');
  };

  return (
    <div className="App">
      {loading && <LoadingScreen />}
      
      <BackgroundWatermark />
      
      <Header 
        onLeftMenuClick={() => setLeftSidebarOpen(!leftSidebarOpen)}
        onRightMenuClick={() => setRightSidebarOpen(!rightSidebarOpen)}
        onSignUpClick={() => setShowSignUp(true)}
        user={user}
      />

      <LeftSidebar 
        isOpen={leftSidebarOpen} 
        onClose={() => setLeftSidebarOpen(false)} 
      />

      <RightSidebar 
        isOpen={rightSidebarOpen} 
        onClose={() => setRightSidebarOpen(false)}
        onNavigate={scrollToSection}
      />

      <main className="main-content">
        <div ref={aboutRef}>
          <AboutSection />
        </div>
        <div ref={servicesRef}>
          <ServicesSection />
        </div>
        <div ref={designsRef}>
          <DesignSection />
        </div>
        <div ref={mobileAppsRef}>
          <MobileAppSection />
        </div>
        <div ref={digitalMarketingRef}>
          <DigitalMarketingSection />
        </div>
        <div ref={globalTieupsRef}>
          <GlobalTieupsSection />
        </div>
        <div ref={contactRef}>
          <ContactSection onToast={displayToast} />
        </div>
        
      </main>

      <BottomInput onToast={displayToast} />

      {showSignUp && (
        <SignUpModal 
          onClose={() => setShowSignUp(false)}
          onSignUp={handleSignUp}
        />
      )}

      {showToast && (
        <div className="toast">
          {toastMessage}
        </div>
      )}

      <div className="particle-background"></div>

      <footer className={`app-footer ${footerVisible ? 'visible' : ''}`}>
        © {new Date().getFullYear()} Gentrobyte. Powered by Gentrobyte AI Labs.
      </footer>
    </div>
  );
}

export default App;
